<ng-container *transloco="let t">
@if (hasVisibleActions) {
  <!-- Desktop: original card layout -->
  <div class="card desktop-loan-actions">
    <div class="card-header d-flex align-items-center justify-content-center" style="min-height: 50px; padding-top: 6px">
      <h5 class="opacity-80">{{ t('portal.loanActions.title') }}</h5>
    </div>
    @if (actionsApplicable) {
      <div class="card-body">
        <div class="btn-loan-actions">
          @if (actionsApplicable.hasPreApprovalLetter && hasPrequalDetails) {
            <a href="javascript:void(0)"
              class="btn btn-sm bp-primary-bg-color d-inline-flex align-items-center" (click)="openGeneratePrequalLetterDialog()">
              <i class="text-white fa fa-file-alt me-2"></i>{{ t('portal.loanActions.generatePreapprovalLetter') }}
            </a>
          }

          @if (actionsApplicable.isMortgageCalculatorEnabled) {
            <a href="javascript:void(0)"
              class="btn btn-sm bp-primary-bg-color d-inline-flex align-items-center" (click)="openMortgageCalculatorModal()">
              <i class="text-white fa fa-calculator me-2"></i>{{ t('portal.loanActions.openPaymentCalculator') }}
            </a>
          }

          @if (!isAgent && actionsApplicable.hasAssetVerificationTasks) {
            <a href="javascript:void(0)"
              class="btn btn-sm bp-primary-bg-color d-inline-flex align-items-center" (click)="onOpenAssetVerificationClicked()">
              <i class="text-white fa fa-university me-2"></i>{{ t('portal.loanActions.verifyYourAssets') }}
            </a>
          }

          @if (!isAgent && actionsApplicable.hasIncomeVerificationTasks) {
            <a href="javascript:void(0)"
              class="btn btn-sm bp-primary-bg-color d-inline-flex align-items-center" (click)="onOpenIncomeVerificationClicked()">
              <i class="text-white fas fa-money-bill me-2"></i>{{ t('portal.loanActions.verifyYourEmpIncome') }}
            </a>
          }

          @if (actionsApplicable.isUploadingAdditionalDocsEnabled) {
            <a href="javascript:void(0)"
              class="btn btn-sm bp-primary-bg-color d-inline-flex align-items-center" (click)="onAddAdditionalDocumentsClicked()">
              <i class="fas fa-paperclip text-white me-2"></i>{{ t('portal.loanActions.addAdditionalDocuments') }}
            </a>
          }

          @if (!isAgent && actionsApplicable.hasPaymentLink && paymentLinkConfig.isVisible && paymentLinkConfig.paymentLink) {
            <a
              href="{{paymentLinkConfig.paymentLink || ''}}" target="_blank"
              class="btn btn-sm bp-primary-bg-color d-inline-flex align-items-center">
              <i class="text-white fas fa-money-bill me-2"></i>{{paymentLinkConfig.buttonText || t('portal.loanActions.makeAPayment')}}
            </a>
          }
        </div>
      </div>
    }
  </div>

  <!-- Mobile: native-style action buttons without container or header -->
  @if (actionsApplicable) {
    <div class="mobile-loan-actions d-none">
      @if (actionsApplicable.hasPreApprovalLetter && hasPrequalDetails) {
        <a href="javascript:void(0)" class="mobile-action-item" (click)="openGeneratePrequalLetterDialog()">
          <div class="mobile-action-icon-wrap">
            <i class="fa fa-file-alt"></i>
          </div>
          <div class="mobile-action-label">
            <span class="mobile-action-title">{{ t('portal.loanActions.generatePreapprovalLetter') }}</span>
            <span class="mobile-action-desc">{{ t('portal.loanActions.descGeneratePreapproval') }}</span>
          </div>
          <i class="fas fa-chevron-right mobile-action-chevron"></i>
        </a>
      }

      @if (actionsApplicable.isMortgageCalculatorEnabled) {
        <a href="javascript:void(0)" class="mobile-action-item" (click)="openMortgageCalculatorModal()">
          <div class="mobile-action-icon-wrap">
            <i class="fa fa-calculator"></i>
          </div>
          <div class="mobile-action-label">
            <span class="mobile-action-title">{{ t('portal.loanActions.paymentCalculator') }}</span>
            <span class="mobile-action-desc">{{ t('portal.loanActions.descPaymentCalculator') }}</span>
          </div>
          <i class="fas fa-chevron-right mobile-action-chevron"></i>
        </a>
      }

      @if (!isAgent && actionsApplicable.hasAssetVerificationTasks) {
        <a href="javascript:void(0)" class="mobile-action-item" (click)="onOpenAssetVerificationClicked()">
          <div class="mobile-action-icon-wrap">
            <i class="fa fa-university"></i>
          </div>
          <div class="mobile-action-label">
            <span class="mobile-action-title">{{ t('portal.loanActions.verifyYourAssets') }}</span>
            <span class="mobile-action-desc">{{ t('portal.loanActions.descVerifyAssets') }}</span>
          </div>
          <i class="fas fa-chevron-right mobile-action-chevron"></i>
        </a>
      }

      @if (!isAgent && actionsApplicable.hasIncomeVerificationTasks) {
        <a href="javascript:void(0)" class="mobile-action-item" (click)="onOpenIncomeVerificationClicked()">
          <div class="mobile-action-icon-wrap">
            <i class="fas fa-money-bill"></i>
          </div>
          <div class="mobile-action-label">
            <span class="mobile-action-title">{{ t('portal.loanActions.verifyEmploymentIncome') }}</span>
            <span class="mobile-action-desc">{{ t('portal.loanActions.descVerifyEmployment') }}</span>
          </div>
          <i class="fas fa-chevron-right mobile-action-chevron"></i>
        </a>
      }

      @if (actionsApplicable.isUploadingAdditionalDocsEnabled) {
        <a href="javascript:void(0)" class="mobile-action-item" (click)="onAddAdditionalDocumentsClicked()">
          <div class="mobile-action-icon-wrap">
            <i class="fas fa-paperclip"></i>
          </div>
          <div class="mobile-action-label">
            <span class="mobile-action-title">{{ t('portal.loanActions.addAdditionalDocuments') }}</span>
            <span class="mobile-action-desc">{{ t('portal.loanActions.descAddDocuments') }}</span>
          </div>
          <i class="fas fa-chevron-right mobile-action-chevron"></i>
        </a>
      }

      @if (!isAgent && actionsApplicable.hasPaymentLink && paymentLinkConfig.isVisible && paymentLinkConfig.paymentLink) {
        <a href="{{paymentLinkConfig.paymentLink || ''}}" target="_blank" class="mobile-action-item">
          <div class="mobile-action-icon-wrap">
            <i class="fas fa-credit-card"></i>
          </div>
          <div class="mobile-action-label">
            <span class="mobile-action-title">{{paymentLinkConfig.buttonText || t('portal.loanActions.makeAPayment')}}</span>
            <span class="mobile-action-desc">{{ t('portal.loanActions.descMakePayment') }}</span>
          </div>
          <i class="fas fa-chevron-right mobile-action-chevron"></i>
        </a>
      }
    </div>
  }
}
</ng-container>
